export default function Hero() {
  const scrollToSection = (id) => {
    document.getElementById(id).scrollIntoView({
      behavior: "smooth",
    });
  };

  return (
    <section className="relative bg-gradient-to-br from-gray-900 via-black to-gray-900 text-white min-h-screen flex items-center px-4 sm:px-6 lg:px-8 overflow-hidden">
      {/* Animated Background Elements */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-20 left-10 w-72 h-72 bg-green-500 rounded-full blur-3xl animate-pulse"></div>
        <div className="absolute bottom-20 right-10 w-96 h-96 bg-blue-500 rounded-full blur-3xl animate-pulse delay-1000"></div>
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-80 h-80 bg-purple-500 rounded-full blur-3xl animate-pulse delay-700"></div>
      </div>

      <div className="relative max-w-5xl mx-auto text-center z-10">
        {/* Badge */}
        <div className="inline-block mb-6 px-4 py-1.5 bg-white/10 backdrop-blur-sm rounded-full border border-white/20">
          <span className="text-xs sm:text-sm font-medium text-green-400">
            🚀 Trusted by 500+ Businesses
          </span>
        </div>

        {/* Title */}
        <h1 className="text-3xl sm:text-5xl md:text-6xl lg:text-7xl font-extrabold leading-tight">
          Build Powerful
          <span className="block text-transparent bg-clip-text bg-gradient-to-r from-green-400 via-emerald-300 to-blue-400 mt-2">
            Digital Products
          </span>
          <span className="block text-gray-300 mt-2 text-2xl sm:text-3xl md:text-4xl">
            with MegaMind Business Solutions
          </span>
        </h1>

        {/* Subtitle */}
        <p className="mt-6 text-sm sm:text-base md:text-lg text-gray-400 max-w-2xl mx-auto leading-relaxed">
          We create modern websites and mobile apps using the latest
          technologies to help your business grow faster in the digital world.
        </p>

        {/* Buttons */}
        <div className="mt-8 flex flex-col sm:flex-row justify-center gap-4">
          <button
            onClick={() => scrollToSection("pricing")}
            className="group relative px-8 py-3.5 bg-gradient-to-r from-green-500 to-emerald-600 text-white rounded-xl font-semibold text-sm sm:text-base shadow-lg shadow-green-500/30 hover:shadow-green-500/50 hover:scale-105 transition-all duration-300 overflow-hidden"
          >
            <span className="relative z-10">Get Started Free</span>
            <div className="absolute inset-0 bg-gradient-to-r from-green-600 to-emerald-700 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
          </button>

          <button
            onClick={() => scrollToSection("projects")}
            className="px-8 py-3.5 bg-white/10 backdrop-blur-sm border border-white/30 text-white rounded-xl font-semibold text-sm sm:text-base hover:bg-white hover:text-black hover:scale-105 transition-all duration-300"
          >
            View Our Work
          </button>
        </div>

        {/* Trust Indicators */}
        <div className="mt-8 flex flex-wrap justify-center gap-6 sm:gap-10">
          <div className="flex items-center gap-2">
            <span className="text-green-400 text-lg">✦</span>
            <span className="text-xs sm:text-sm text-gray-400">50+ Projects</span>
          </div>
          <div className="flex items-center gap-2">
            <span className="text-blue-400 text-lg">✦</span>
            <span className="text-xs sm:text-sm text-gray-400">99% Satisfaction</span>
          </div>
          <div className="flex items-center gap-2">
            <span className="text-purple-400 text-lg">✦</span>
            <span className="text-xs sm:text-sm text-gray-400">24/7 Support</span>
          </div>
        </div>

        {/* EMI Message */}
        <div className="mt-10 pt-6 border-t border-white/10">
          <p className="text-sm sm:text-base text-gray-400">
            💳 Don't worry about budget — 
            <span className="text-green-400 font-semibold mx-1">0% interest EMI</span>
            available. Get your website delivered 
            <span className="text-blue-400 font-semibold mx-1">fast</span>
            and 
            <span className="text-amber-400 font-semibold ml-1">hassle-free</span>.
          </p>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce">
        <div className="w-6 h-10 border-2 border-white/30 rounded-full flex justify-center">
          <div className="w-1 h-3 bg-white/50 rounded-full mt-2 animate-pulse"></div>
        </div>
      </div>
    </section>
  );
}